import { EditorState } from '../text-editor.types'
import { getTextBeforeCaret } from './utils'

export function determineEditorState(mentionIsDisabled: boolean): EditorState {
  const textBeforeCaret = getTextBeforeCaret()

  if (mentionIsDisabled) return 'TEXT'
  if (textBeforeCaret === '') return 'TEXT'
  if (textBeforeCaret.match(/^@+$/)) return 'PRE_MENTION'
  if (textBeforeCaret.match(/^@+[^@]+$/)) return 'MENTION'
  return 'TEXT'
}
